import { render, staticRenderFns } from "./SedaparLogo.vue?vue&type=template&id=e94f568a&scoped=true"
import script from "./SedaparLogo.vue?vue&type=script&lang=js"
export * from "./SedaparLogo.vue?vue&type=script&lang=js"
import style0 from "./SedaparLogo.vue?vue&type=style&index=0&id=e94f568a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94f568a",
  null
  
)

export default component.exports